import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Router } from '@angular/router';

import { catchError } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { UserService } from '@core/services';
import { environment } from 'src/environments/environment';


@Injectable()
export class HttpErrorsIntercepter implements HttpInterceptor
{
    constructor(private userService: UserService,
                private router: Router) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const apiUrl = environment.apiUrl.replace('/v1', '');
        if(!req.url.includes(apiUrl)) return next.handle(req);
        return next.handle(req)
        .pipe(catchError(error => {
            if(error instanceof HttpErrorResponse) {
                if(error.status == 401) {
                    this.userService.unlogin();
                    this.router.navigate(['/auth']);
                }
            }
            return throwError(error);
        }));
    }
}